<template>
    <div class="ppv2-space-y-4">
        <InfoMessageBox class="ppv2-mt-2" :title="$t('messageBox.wallet.start.title')" color="info" />
        <div class="ppv2-flex ppv2-flex-col ppv2-space-y-4">
            <div class="ppv2-relative ppv2-p-4 ppv2-cursor-pointer">
                <div class="ppv2-absolute ppv2-top-2 ppv2-right-2">
                    <BaseSwitch v-model="formData.is_wallet_enabled" required />
                </div>
                <div>
                    <div class="ppv2-text-base ppv2-text-gray-800 poppinsMedium">
                        <BaseLabel :label="$t('wallet.fields.enableWallet.label')" />
                    </div>
                    <div class="ppv2-flex ppv2-items-center ppv2-space-x-2 ppv2-mt-1 ppv2-text-xs ppv2-text-gray-500">
                        <BaseParagraphe>
                            {{ $t('wallet.fields.enableWallet.description') }}
                        </BaseParagraphe>
                    </div>
                </div>
            </div>
            <div class="ppv2-relative ppv2-p-4 ppv2-cursor-pointer">
                <div class="ppv2-absolute ppv2-top-2 ppv2-right-2">
                    <BaseSwitch v-model="formData.is_wallet_cachback_enabled" required />
                </div>
                <div>
                    <div class="ppv2-text-base ppv2-text-gray-800 poppinsMedium">
                        <BaseLabel
                            :label="$t('wallet.fields.enableWallet.labelCashback')"
                            :description="$t('wallet.fields.enableWallet.additionalOfferDescription')"
                        />
                    </div>
                    <div class="ppv2-flex ppv2-items-center ppv2-space-x-2 ppv2-mt-1 ppv2-text-xs ppv2-text-gray-500">
                        <BaseParagraphe>
                            {{ $t('wallet.fields.enableWallet.descriptionCashback') }}
                        </BaseParagraphe>
                    </div>
                </div>
            </div>
            <BaseInput
                v-model="formData.wallet_percent"
                :label="$t('wallet.fields.bonusOffered.label')"
                class="ppv2-mt-6"
                :placeholder="$t('wallet.fields.bonusOffered.placeholder')"
                :tooltipMsg="$t('wallet.fields.bonusOffered.infoMessage', { symbol: $symbolCurrency })"
                required
            >
                <template #leftIcon>
                    <svg
                        class="ppv2-w-4 ppv2-h-4 ppv2-text-gray-700"
                        viewBox="0 0 24 25"
                        fill="none"
                        xmlns="http://www.w3.org/2000/svg"
                    >
                        <path
                            d="M19 5.5L5 19.5M9 7C9 8.38071 7.88071 9.5 6.5 9.5C5.11929 9.5 4 8.38071 4 7C4 5.61929 5.11929 4.5 6.5 4.5C7.88071 4.5 9 5.61929 9 7ZM20 18C20 19.3807 18.8807 20.5 17.5 20.5C16.1193 20.5 15 19.3807 15 18C15 16.6193 16.1193 15.5 17.5 15.5C18.8807 15.5 20 16.6193 20 18Z"
                            stroke="black"
                            stroke-width="2"
                            stroke-linecap="round"
                            stroke-linejoin="round"
                        />
                    </svg>
                </template>
            </BaseInput>
        </div>
    </div>
</template>

<script>
import InfoMessageBox from '../../../Shared/InfoMessageBox.vue'
import BaseSwitch from '../../../Shared/BaseSwitch.vue'
import BaseLabel from '../../../Shared/BaseLabel.vue'
import BaseInput from '../../../Shared/BaseInput.vue'
import BaseParagraphe from '../../../Shared/BaseParagraphe.vue'

export default {
    name: 'Wallet',
    components: {
        InfoMessageBox,
        BaseSwitch,
        BaseLabel,
        BaseInput,
        BaseParagraphe,
    },
    data() {
        return {
            formData: {
                is_wallet_enabled: false,
                is_wallet_cachback_enabled: false,
                wallet_percent: null,
            },
        }
    },
    computed: {
        establishment() {
            return this.$store.getters['establishment/establishment']
        },
    },
    watch: {
        establishment: {
            handler() {
                this.initializeForm()
            },
            immediate: true,
            deep: true,
        },
        formData: {
            handler(newVal) {
                this.$emit('update', newVal)
            },
            deep: true,
        },
    },
    methods: {
        initializeForm() {
            const fields = ['is_wallet_enabled', 'is_wallet_cachback_enabled', 'wallet_percent']
            fields.forEach((field) => {
                if (this.establishment.hasOwnProperty(field)) {
                    this.formData[field] = this.establishment[field]
                }
            })
        },
    },
}
</script>

<style scoped></style>
